import { render } from "./CheckoutFooter.vue?vue&type=template&id=4108516c"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__